import { createIcon } from '../utils';

export const HeartPlusLogoIcon = createIcon(
  ({ ref, className, width, height, ...rest }) => (
    <svg
      ref={ref}
      className={className}
      width={width}
      height={height}
      viewBox="0 0 79 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M15.6637 15.7162V0H0V15.7162V31.4324V47.1486H15.6637V31.4324H31.3274V15.7162H15.6637Z"
        fill="currentColor"
      />
      <path
        d="M46.991 -1.71661e-05H31.3273V15.7162H46.991V-1.71661e-05Z"
        fill="currentColor"
      />
      <path
        d="M46.991 31.4323H31.3273V47.1485H46.991V31.4323Z"
        fill="currentColor"
      />
      <path
        d="M78.3187 -1.71661e-05H62.655V15.7162H78.3187V-1.71661e-05Z"
        className="fill-primary"
      />
      <path
        d="M78.3187 31.4323H62.655V47.1485H78.3187V31.4323Z"
        className="fill-primary"
      />
    </svg>
  ),
  {
    displayName: 'HeartPlusLogoIcon',
    defaultVariant: 'foreground',
    classNameBase: 'fill-current',
  },
);
